/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Show/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaVisibility from 'DesignSystem/Svgs/TysiaVisibility/index'



/** @type {import('Simple/types.js').View} */
export default function Show({
  children,
  viewPath = "/App/Auth/SignIn/Credentials/Password/VisibilityAction/Show"
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaVisibility
  viewPath={`${viewPath}/TysiaVisibility`}
 fill2={dtColorsNeutral400}
/>
{children}
</React.Fragment>)
}